import { Box, Button, Stack, Typography } from "@mui/material";
import { Add, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { usersUrl } from "../../utils/urls"; // <-- assume this is like '/user'
import ServerPaginationDataGrid from "../../components/tables/ServerPaginationDataGrid";
import PageHeader from "../../components/page-layout/PageHeader";

const Vendors = () => {
  const navigate = useNavigate();

  const columns = [
    { field: "name", headerName: "Vendor Name", flex: 1 },
    {
      field: "phoneNumber",
      headerName: "Mobile Number",
      width: 200,
      renderCell: ({ row }) => (
        <Typography>
          {row.phoneNumber
            ? `+91 ${row.phoneNumber.replace(/^(\+91|91)/, "")}`
            : "N/A"}
        </Typography>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      width: 240,
      renderCell: ({ row }) => <Typography>{row.email}</Typography>,
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      sortable: false,
      renderCell: ({ row }) => (
        <Button
          startIcon={<Edit />}
          size="small"
          onClick={() => navigate(`edit/${row.id}`)}
        >
          Edit
        </Button>
      ),
    },
  ];
const query={role:"VENDOR"}
  return (
    <Stack spacing={2}>
      <PageHeader
        title={"Vendors"}
        lead={
          "Manage your vendors here. Add new vendors or edit existing vendor details."
        }
        showBack={true}
        buttonTitle={"Add Vendor"}
        buttonOnClick={() => navigate("add")}
      />

      <ServerPaginationDataGrid
        name="vendor-table"
        url={usersUrl}
        columns={columns}
        query={query}
      />
    </Stack>
  );
};

export default Vendors;
